/* eslint-disable @typescript-eslint/no-explicit-any */
import moment from 'moment';
// Utils
import { getSessionStorageItem, setSessionStorageItem, validArray } from 'utils';
import { getOrganisationIndex, mutateEvent, mutateFilters, mutateDispatcherCloseEvent } from 'utils/events';
// App Actions
import { addNotification } from 'context/AppContext/actions';
// Actions
import * as eventActions from 'context/EventContext/actions';
// Flags
import * as eventConstants from 'context/EventContext/statusFlags';
// Services
import { getProductionEvents, patchProductionEvents } from 'services/manufacturingV1/productionEvents';
import { patchSalesOrders } from 'services/salesOrderV1/salesOrders';
// Types
import { APIResponseProps } from 'types/global';
import { packSiteMapping } from 'pages/EventLog/config/index';
import { ProductionEventProps } from 'types/productionEvent';
import * as types from './types';

function filteredEvent(event: ProductionEventProps) {
  let test = false;
  const org = getSessionStorageItem({ item: 'defaultOrganisation' }).orgDescription;
  for (const [key, items] of Object.entries(packSiteMapping)) {
    if ( org === key) {
      test = items.includes(event.orderInfo.packSite)
    }     
  }
  return test;  
}

export async function getEvents({
  appDispatch,
  eventDispatch,
  filters,
  orgRef,
}:types.GetEventsProps) {
  eventDispatch(eventActions.setEventState(eventConstants.GET_EVENTS));
  const { errorMessage, response }:APIResponseProps = await getProductionEvents({
    orgRef,
    reqParams: mutateFilters(filters),
  });
  if (response) {
    const { salesOrders, metadata } = response;
    const filteredSalesOrders = salesOrders.filter(filteredEvent);
    if (filters.offSet === 0) {
      eventDispatch(eventActions.setEvents(filteredSalesOrders));
    } else {
      eventDispatch(eventActions.appendEvents(filteredSalesOrders));
    }

    // Call next offset if no fildered order found
    if (filteredSalesOrders.length === 0 && metadata.links.next !== null ) {
      eventDispatch(eventActions.setEventFilters({ ...filters, offSet : filters.offSet + 10  }));
    }

    // Update no more event
    eventDispatch(eventActions.setNoMoreEvent(metadata.links.next !== null))
    // await delay(500);
    eventDispatch(eventActions.setEventState(eventConstants.GET_EVENTS_SUCCESS));
  }
  if (errorMessage) {
    eventDispatch(eventActions.setEventState(eventConstants.GET_EVENTS_ERROR));
    eventDispatch(eventActions.setNoMoreEvent(false));
    if (filters.offSet > 0) {
      appDispatch(addNotification({
        label: 'Some error has occured. Unable to retireve data from system',
        type: 'success',
      }))
    }
  }
}

export async function getEventNotifications({
  eventDispatch,
  orgRef,
}:types.GetEventNotificationsProps) {
  eventDispatch(eventActions.setEventState(eventConstants.GET_EVENT_NOTIFICATIONS));
  const { errorMessage, response }:APIResponseProps = await getProductionEvents({
    orgRef,
    reqParams:{
      fromDate: moment().subtract(1, 'day').startOf('day').format('YYYY-MM-DD HH:mm:ss'),
      'processingStatus[in]': 'ERROR',
      toDate: moment().add(1, 'day').startOf('day').format('YYYY-MM-DD HH:mm:ss'),
    },
  });
  if (response) {
    const { eventManagerProductionEvents } = response;
    eventDispatch(eventActions.setEventNotifications(eventManagerProductionEvents));
    eventDispatch(eventActions.setEventState(eventConstants.GET_EVENT_NOTIFICATIONS_SUCCESS));
  }
  if (errorMessage) {
    eventDispatch(eventActions.setEventState(eventConstants.GET_EVENT_NOTIFICATIONS_ERROR));
  }
}


export async function markEventNotificationAsRead({
  eventDispatch,
  notification,
  readEventNotifications,
  orgRef,
}:types.MarkEventNotificationAsReadProps) {
  eventDispatch(eventActions.setNotificationAsRead(notification));
  let sessionReadEventNotifications = getSessionStorageItem({ item: 'readEventNotifications' });
  if (sessionReadEventNotifications && validArray(sessionReadEventNotifications)) {
    const i = getOrganisationIndex(orgRef, sessionReadEventNotifications);
    sessionReadEventNotifications[i].notifications = [...readEventNotifications, notification];
  } else {
    sessionReadEventNotifications = [{
      orgRef,
      notifications: [notification],
    }]
  }
  setSessionStorageItem({ key: 'readEventNotifications', item: sessionReadEventNotifications });
}

export async function resendEvents({
  appDispatch,
  eventDispatch,
  eventFilters,
  event,
  orgRef,
}: types.ResendEventsProps) {
  const resendEvent = mutateEvent({ event });
  eventDispatch(eventActions.setEventState(eventConstants.RESEND_EVENTS));
  try {
    await patchProductionEvents({
      events: resendEvent,
      dispatcherOrderId: event.orderInfo.id,
    });
    eventDispatch(eventActions.setEvents([]));
    eventDispatch(eventActions.setEventFilters({ ...eventFilters, offSet : 0 }));
    eventDispatch(eventActions.setEventState(eventConstants.RESEND_EVENTS_SUCCESS));
    appDispatch(addNotification({
      label: 'Events successfully submitted',
      type: 'success',
    }))
  } catch (error: any) {
    let errorMessage;
    if (error.apiStatusCode === '409') {
      errorMessage = 'Some Events Are No Longer In Fail Status';
    } else if (error.apiStatusCode) {
      errorMessage = 'An Error Occurred Submitting Events';
    } else {
      errorMessage = error.message;
    }
    eventDispatch(eventActions.setEventState(eventConstants.RESEND_EVENTS_ERROR));
    appDispatch(addNotification({
      label: errorMessage,
      type: 'error',
    }))
    // eventDispatch(eventActions.setEvents([]));
    // eventDispatch(eventActions.setEventFilters({ ...eventFilters, offSet : 0 }));
  }
}

export async function patchEvents({
  appDispatch,
  eventDispatch,
  event,
  eventFilters,
}: types.PatchEventsProps) {
  eventDispatch(eventActions.setEventState(eventConstants.RESEND_EVENTS));
  try {
    await patchSalesOrders({
      event,
    });
    eventDispatch(eventActions.setEventState(eventConstants.RESEND_EVENTS_SUCCESS));
  } catch (error: any) {
    let errorMessage;
    if (error.apiStatusCode === '409') {
      errorMessage = 'Some Events Are No Longer In Fail Status';
    } else if (error.apiStatusCode) {
      errorMessage = 'An Error Occurred Submitting Events';
    } else {
      errorMessage = error.message;
    }
    eventDispatch(eventActions.setEventState(eventConstants.RESEND_EVENTS_ERROR));
    appDispatch(addNotification({
      label: errorMessage,
      type: 'error',
    }))
  }
}

export async function closeEvents({
  appDispatch,
  eventDispatch,
  eventFilters,
  event,
  orgRef,
}: types.ResendEventsProps) {
  const resendEvent = mutateDispatcherCloseEvent({ event });
  eventDispatch(eventActions.setEventState(eventConstants.RESEND_EVENTS));
  try {
    await patchProductionEvents({
      events: resendEvent,
      dispatcherOrderId: event.orderInfo.id,
    });
    eventDispatch(eventActions.setEvents([]));
    eventDispatch(eventActions.setEventFilters({ ...eventFilters, offSet : 0 }));
    eventDispatch(eventActions.setEventState(eventConstants.RESEND_EVENTS_SUCCESS));
    appDispatch(addNotification({
      label: 'Events successfully submitted',
      type: 'success',
    }))
  } catch (error: any) {
    let errorMessage;
    if (error.apiStatusCode === '409') {
      errorMessage = 'Some Events Are No Longer In Fail Status';
    } else if (error.apiStatusCode) {
      errorMessage = 'An Error Occurred Submitting Events';
    } else {
      errorMessage = error.message;
    }
    eventDispatch(eventActions.setEventState(eventConstants.RESEND_EVENTS_ERROR));
    appDispatch(addNotification({
      label: errorMessage,
      type: 'error',
    }))
    // eventDispatch(eventActions.setEvents([]));
    // eventDispatch(eventActions.setEventFilters({ ...eventFilters, offSet : 0 }));
  }
}
